import React from 'react';
import { Result, Typography } from 'antd';
import { ReadFilled } from '@ant-design/icons';
import { Layout } from '../../components/Layout';
import { ApiKeys } from './ApiKeys';

export const ApiUsage = () => {
  return (
    <Layout.Content>
      <div className="u-mb-xxlarge">
        <ApiKeys />
      </div>
      <Typography.Title level={4} className="u-text-align-center">API Usage:</Typography.Title>
      <Result
        icon={<ReadFilled />}
        title="Coming soon!"
      />
    </Layout.Content>
  );
}
